// Mock data para MASTER-CLASS Academia de Música

export const heroData = {
  title: "MASTER-CLASS",
  subtitle: "Academia de Música",
  description: "Donde la música se vive. Mucho más que clases, un ambiente cercano para todas las edades.",
  ctaText: "Acércate a Conocernos",
  backgroundImage: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxtdXNpYyUyMHN0dWRpb3xlbnwwfHx8YmxhY2t8MTc3MTEyODMwNnww&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  title: "Sobre Nuestra Academia",
  description: "En MASTER-CLASS creemos que la música no se enseña: se transmite. Trabajamos con niños, jóvenes y adultos que quieren aprender, mejorar y disfrutar tocando de verdad. Aquí cada alumno importa, cada clase cuenta y cada actuación es una experiencia inolvidable.",
  highlights: [
    {
      icon: "Music",
      title: "Profesores Cualificados",
      description: "Músicos preparados, cercanos, capacitados y apasionados por la música"
    },
    {
      icon: "Users",
      title: "Clases Personalizadas",
      description: "Nuestro enfoque personalizado permite diseñar un plan de aprendizaje ajustado a la edad, nivel y metas de cada alumno"
    },
    {
      icon: "Award",
      title: "+7 Años de Experiencia",
      description: "MASTER-CLASS es un espacio donde niños, jóvenes y adultos crecen a través de la música. Una comunidad que no deja de ampliarse curso tras curso"
    },
    {
      icon: "Heart",
      title: "Ambiente Inspirador",
      description: "Instalaciones adaptadas, en un ambiente seguro, con espacios organizados y cómodos tanto para niños como para adultos"
    }
  ],
  image: "https://images.unsplash.com/photo-1602879030257-f725a352fb32?crop=entropy&cs=srgb&fm=jpg&q=85"
};

export const coursesData = {
  title: "Nuestras Asignaturas",
  subtitle: "Explora nuestros programas diseñados para desarrollar tu talento musical",
  courses: [
    {
      id: 1,
      name: "Piano",
      description: "Desde cero, sin necesidad de conocimientos musicales previos. Siéntate y toca. Desde clásico hasta moderno. Tus melodías favoritas. Aprenderás técnica y expresión musical. La teoría incluida en la práctica. Agudiza tu oído y mejora la lectura.",
      image: "https://images.unsplash.com/photo-1552422535-c45813c61732?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwaWFub3xlbnwwfHx8YmxhY2t8MTc3MTEyODMxMHww&ixlib=rb-4.1.0&q=85",
      levels: "Todos los niveles",
      duration: "Niño, joven o adulto",
      icon: "Piano"
    },
    {
      id: 2,
      name: "Guitarra",
      description: "Ofrecemos un aprendizaje progresivo con atención personalizada dentro de un entorno dinámico y participativo. Además, fomentamos el trabajo en grupo para que los alumnos vivan la experiencia de tocar en conjunto como en una banda real.",
      image: "https://images.unsplash.com/photo-1516924962500-2b4b3b99ea02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxndWl0YXJ8ZW58MHx8fGJsYWNrfDE3NzExMjgzMTR8MA&ixlib=rb-4.1.0&q=85",
      levels: "Principiante a avanzado",
      duration: "Niño, joven o adulto",
      icon: "Guitar"
    },
    {
      id: 3,
      name: "Canto",
      description: "\"Voz en juego\" es la metodología propia de MASTER-CLASS cuyo objetivo es el desarrollo de la voz de forma natural, segura y progresiva, priorizando la confianza, la afinación funcional y el disfrute del alumno.",
      image: "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxtaWNyb3Bob25lfGVufDB8fHx8MTc3MTE1MTM2MXww&ixlib=rb-4.1.0&q=85",
      levels: "Todos los niveles",
      duration: "Niño, joven o adulto",
      icon: "Mic"
    },
    {
      id: 4,
      name: "Batería",
      description: "Nuestras clases de batería están pensadas para que el alumno disfrute desde el primer ritmo. Trabajamos coordinación, tempo y técnica de forma progresiva, aplicándolo siempre a canciones reales y estilos actuales.",
      image: "https://images.unsplash.com/photo-1571327073757-71d13c24de30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHx2aW9saW4lMjBkcnVtc3xlbnwwfHx8YmxhY2t8MTc3MTEyODMxOHww&ixlib=rb-4.1.0&q=85",
      levels: "Principiante a avanzado",
      duration: "Niño, joven o adulto",
      icon: "Drum"
    },
    {
      id: 5,
      name: "Violín",
      description: "En MASTER-CLASS enseñamos violín con un método cercano y práctico: más allá de la técnica fomentamos la creatividad, la expresión y la confianza. Aprender a tocar el violín nunca ha sido tan motivador.",
      image: "https://images.unsplash.com/photo-1472312656035-eeef4726de6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx2aW9saW58ZW58MHx8fGJsYWNrfDE3NzExMjgzMjJ8MA&ixlib=rb-4.1.0&q=85",
      levels: "Todos los niveles",
      duration: "Niño, joven o adulto",
      icon: "Music2"
    },
    {
      id: 6,
      name: "Programa Infantil",
      description: "MASTER-KIDS es nuestro programa de iniciación musical para niños de 3 a 6 años. Un espacio donde experimentan con sonidos, ritmo y movimiento a través del juego, la creatividad y la expresión corporal. Aquí no solo aprenden música: desarrollan coordinación, oído, confianza y trabajo en grupo.",
      image: "/programa-infantil.png",
      levels: "3-6 años",
      duration: "",
      icon: "Baby"
    }
  ]
};

export const galleryData = {
  title: "Galería",
  subtitle: "Un vistazo a nuestras instalaciones y momentos especiales",
  images: [
    {
      id: 1,
      url: "/assets/gallery/foto1_banda.jpg",
      alt: "Banda ensayando"
    },
    {
      id: 2,
      url: "/assets/gallery/foto2_bateria.jpg",
      alt: "Clase de batería"
    },
    {
      id: 3,
      url: "/assets/gallery/foto3_piano.jpg",
      alt: "Clase de piano"
    },
    {
      id: 4,
      url: "/assets/gallery/foto4_bajo.jpg",
      alt: "Clase de bajo"
    }
  ]
};

export const contactData = {
  title: "Contacto",
  subtitle: "¿Listo para comenzar tu viaje musical? Contáctanos hoy",
  info: {
    phone: "644 464 599",
    email: "info@masterclassacademia.com",
    address: "C/ Máximo Garcia Garrido 10-12\n48980 SANTURTZI - Bizkaia",
    hours: "Lunes a Viernes: 10:00 - 13:00h y 16:00 - 21:00h"
  },
  socialMedia: [
    { platform: "Facebook", url: "https://www.facebook.com/masterclassstz", icon: "Facebook" },
    { platform: "Instagram", url: "https://www.instagram.com/masterclass_stz", icon: "Instagram" },
    { platform: "TikTok", url: "https://www.tiktok.com/@masterclass_stz", icon: "TikTok" },
    { platform: "Youtube", url: "https://www.youtube.com/@master-classstz5499", icon: "Youtube" }
  ]
};
